// © Microsoft Corporation. All rights reserved.

/**
 * Prefix that all flights for peregrine will use
 */
const peregrineFlightPrefix: string = "prg-";

/**
 * Goes through the array of flights that is given and will filter out any flight that doesn't start with
 * prg-. It then sorts them and returns a new string[].
 * @param flights Array of flights that we will filter through and return only the peregrine
 * @returns specific flights
 */
export function getPeregrineFlights(flights: string[]): string[] {
    if (!flights || flights.length === 0) {
        return flights;
    }

    let cleanedUpFlights = [];
    flights.forEach((item) => {
        let lowercaseItem = item.toLocaleLowerCase();
        if (lowercaseItem.startsWith(peregrineFlightPrefix)) {
            cleanedUpFlights.push(lowercaseItem);
        }
    });

    return cleanedUpFlights.sort();
}

/**
 * If page experiments have prg-crsmaxdepth flight, return true else false
 * @param flights Array of flights
 * @returns true if contains prg-crsmaxdepth
 */
export function isCrsMaxDepthFlight(flights: string[]): boolean {
    if (!flights || flights.length === 0) {
        return false;
    }

    return flights.indexOf("prg-crsmaxdepth") >= 0;
}